import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Accordion } from "react-bootstrap";
import { toast } from "react-toastify";
import Slider from "react-slick";
import { LoadingScreen } from "Components";
import { TableList } from "./TableList";
import { Todos } from "../../Todos";
import { Filters } from "../Projects/Filters";
import { newAuthService } from "Service/Axios";
import useAuth from "Context/useAuth";
import {
  CHATBOT_MESSAGE_URL,
  DASHBOARD_APPROVAL_HEADER_URL,
  DASHBOARD_APPROVAL_LIST_URL,
} from "Constant/api";
import { useActivityList, useFilterList } from "Constant/apiHooks";
import {
  formatDateWithShortMonth,
  formatDateWithTime,
  getFirstLetterOfName,
} from "Utils";

const settings = {
  infinite: true,
  dots: false,
  arrows: true,
  focusOnSelect: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const Dashboard = () => {
  const { t } = useTranslation();

  const { user, messageList, updateMessage } = useAuth();

  // Boolean States
  const [tableLoading, setTableLoading] = useState(true);
  const [filtersModal, setFiltersModal] = useState(false);

  // Array States
  const [applicantList, setApplicantList] = useState([]);

  // Object States
  const [formData, setFormData] = useState({
    message: "",
  });
  const { message } = formData;

  // const { filterList, setFilterList, duplicateFilterList } = useFilterList();
  const { activityList, loading: activityLoading } = useActivityList();

  // Toggle
  const toggleFiltersModal = () => {
    setFiltersModal(!filtersModal);
  };

  // On Change
  const handleChange = (e) => {
    if (e.target.type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.checked,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
    }
  };

  // Listing
  const getApprovalList = async () => {
    try {
      setTableLoading(true);
      const payload = {};
      const response = await newAuthService(
        DASHBOARD_APPROVAL_LIST_URL,
        "POST",
        payload
      );
      if (response.status) {
        setApplicantList(response.data);
      } else {
        toast.error(
          t("common.messages.notification.failed.somethingWentWrong")
        );
      }
      setTableLoading(false);
    } catch (e) {
      setTableLoading(false);
      toast.error(t("common.messages.notification.failed.unauthorized"));
    }
  };

  useEffect(() => {
    getApprovalList();
  }, []);

  // Submit
  const onSendMessage = async () => {
    const payload = {
      type: "Web",
      text: message,
      application: "Faculty",
    };
    updateMessage(payload);
    const botMessage = {
      type: "web",
      application: "web",
      text: "Loading",
      recipient_id: user.data,
    };
    updateMessage(botMessage);
    const response = await newAuthService(CHATBOT_MESSAGE_URL, "POST", payload);
    if (response.status && response.data.length > 0) {
      for (let i = 0; i < response.data.length; i++) {
        updateMessage(response.data[i]);
      }
    }
  };

  // Table Filter
  // const handleFilterSelectChange = (value, index) => {
  //   let newArr = [...filterList];
  //   newArr[index].values = value;
  //   setFilterList(newArr);
  // };

  // const handleFilterCheckboxChange = (value, index, checkIndex) => {
  //   let newArr = [...filterList];
  //   newArr[index].dropdownValue[checkIndex].checked = value;
  //   const valueArr = newArr[index].dropdownValue.filter(
  //     (ele) => ele.checked === true
  //   );
  //   newArr[index].values = valueArr;
  //   setFilterList(newArr);
  // };

  // const handleFilterSliderChange = (value, id, index) => {
  //   const newArr = filterList.map((f) => {
  //     if (f.questionId === id) {
  //       return {
  //         ...f,
  //         noStartRange: Number(value[0]),
  //         noEndRange: Number(value[1]),
  //       };
  //     } else {
  //       return f;
  //     }
  //   });
  //   // const valueObj = {
  //   //   lowestNo: value[0],
  //   //   highestNo: value[1],
  //   // };
  //   // newArr[index].values = valueObj;
  //   newArr[index].norange = value;
  //   setFilterList(newArr);
  // };

  // const handleFilterAssigneeChange = (value, index, checkIndex) => {
  //   let newArr = [...filterList];
  //   newArr[index].users[checkIndex].isChecked = value;
  //   const valueArr = newArr[index].users.filter(
  //     (ele) => ele.isChecked === true
  //   );
  //   newArr[index].values = valueArr;
  //   newArr[index].userFilter = valueArr;
  //   setFilterList(newArr);
  // };

  // const handleFilterDateChange = (value, index, type) => {
  //   let newArr = [...filterList];
  //   if (type === "startDate") {
  //     newArr[index].startDate = value;
  //   } else {
  //     newArr[index].endDate = value;
  //   }
  //   const dateObj = [
  //     {
  //       name: "start",
  //       value: newArr[index].startDate,
  //       operator: ">=",
  //     },
  //     {
  //       name: "end",
  //       value: newArr[index].endDate,
  //       operator: "<",
  //     },
  //   ];
  //   newArr[index].values = dateObj;
  //   setFilterList(newArr);
  // };

  // const handleSearchFilter = (value) => {
  //   let newArr = [...duplicateFilterList];
  //   if (value.length > 0) {
  //     const searchedFilter = newArr.filter((option) =>
  //       option.label.toLowerCase().includes(value.toLowerCase())
  //     );
  //     setFilterList(searchedFilter);
  //   } else {
  //     setFilterList(duplicateFilterList);
  //   }
  // };

  const onApplyFilter = async (
    filterList
    // ,count
  ) => {
    // setFilterCount(count);
    // setFilterList(filterList);
    getApprovalList(filterList);
  };

  const onResetFilter = () => {
    // setFilterList(duplicateFilterList);
    // setFilterCount(0);
    toggleFiltersModal();
    getApprovalList();
  };

  // Render
  const renderBotMessage = (msg) => {
    if (msg && msg.text) {
      if (msg.text === "Loading") {
        return (
          <>
            <p>Loading</p>
            <div className="botTyping">
              <div className="bounce1"></div>
              <div className="bounce2"></div>
              <div className="bounce3"></div>
            </div>
          </>
        );
      } else {
        return <p>{msg.text}</p>;
      }
    }
    if (msg && msg.image) {
      return <></>;
    }
    if (msg && msg.custom) {
      if (msg.custom.payload === "cardsCarousel") {
        return (
          <div className="approval-list">
            <Slider {...settings}>
              <div className="approval-box">
                <div className="approval-details">
                  <div className="date-box">16-09-22</div>
                  <ul>
                    <li>
                      <small>#JU12565829</small>
                    </li>
                    <li>
                      <h6 className="user-name">Nu'ma Hashim</h6>
                    </li>
                    <li>
                      Degree: <strong>Applied Physics</strong>
                    </li>
                    <li>
                      GPA: <strong>3.00</strong>
                    </li>
                    <li>
                      Citizenship: <strong>Turkmenistan</strong>
                    </li>
                    <li>
                      Avg Rating: <i className="bx bxs-star"></i>
                      <strong>4.3</strong>
                    </li>
                    <li>
                      <button type="button">
                        Open full profile{" "}
                        <i className="bx bx-link-external"></i>
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="d-flex gap-1 mt-3">
                  <button
                    className="btn btn-mini btn-block btn-success"
                    type="button"
                  >
                    Approve
                  </button>
                  <button
                    className="btn btn-mini btn-block btn-danger"
                    type="button"
                  >
                    Deny
                  </button>
                </div>
              </div>
            </Slider>
          </div>
        );
      }
    }
  };

  return (
    <>
      <main className="main d-flex flex-column row-gap-4">
        <div className="">
          <div className="pb-4 d-flex flex-wrap align-items-center">
            <h3 className="mb-0 text-base font-semibold text-grey-900">
              Pending Task
            </h3>
          </div>
          <div className="">
            <div className="search-div">
              <div className="input-group">
                <input
                  type="search"
                  className="form-control form-control-lg border-end-0 bg-grey-50"
                  placeholder="e.g. Search"
                  // value=""
                />
                <span className="input-group-text bg-grey-50">
                  <i className="pluto-search"></i>
                </span>
              </div>
            </div>
          </div>
          <div className="accordion-max-h mt-4 overflow-y-auto overflow-x-hidden p-3 rounded-md border">
            <div className="accordion-theme-1 accordion-arrow-start">
              {tableLoading ? (
                <LoadingScreen />
              ) : (
                applicantList &&
                applicantList.length > 0 && (
                  <Accordion
                    defaultActiveKey={applicantList.map(
                      (applicant) =>
                        `${applicant.projectId}-${applicant.stageId}`
                    )}
                    alwaysOpen
                  >
                    {applicantList &&
                      applicantList.length > 0 &&
                      applicantList.map((applicant, index) => (
                        <Accordion.Item
                          key={`${applicant.stageId}-${index}`}
                          eventKey={`${applicant.projectId}-${applicant.stageId}`}
                          className="position-relative"
                        >
                          <ul className="items-view ms-auto me-0 d-flex position-absolute dashboard-filter-btn right-0 z-20">
                            <li>
                              {/* <button
                                type="button"
                                className="button badge-btn text-nowrap px-3 py-1 border border-grey-200 rounded font-semibold"
                                onClick={toggleFiltersModal}
                              >
                                <i className="bx bx-filter-alt me-1"></i>{" "}
                                {t("common.button.filters")}
                                {filterCount > 0 && (
                                  <span className="badge badge-bg-dynamic">
                                    {filterCount}
                                  </span>
                                )}
                              </button> */}
                            </li>
                          </ul>
                          <Accordion.Header>
                            {applicant.projectName} | {applicant.stageName}
                          </Accordion.Header>
                          <Accordion.Body className="pt-0 px-0 border-top-0 bg-white">
                            <TableList
                              headerList={applicant.headers}
                              dataList={applicant.data}
                              buttonList={applicant.buttons}
                              getApprovalList={getApprovalList}
                            />
                          </Accordion.Body>
                        </Accordion.Item>
                      ))}
                  </Accordion>
                )
              )}
            </div>
          </div>
        </div>

        {/* Recent Activity & Todos */}
        <div className="">
          <div className="row gx-3 gy-4">
            <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="recent-box h-100 p-3 rounded-md border bg-white d-flex flex-column row-gap-2">
                <div className="d-flex flex-wrap align-items-center">
                  <h3 className="mb-0 text-base font-semibold text-grey-900">
                    {t("auth.dashboard.recentActivity.title")}
                  </h3>
                </div>
                {activityLoading ? (
                  <LoadingScreen />
                ) : (
                  <div className="">
                    <ul className="db-approval-list ps-0">
                      {activityList &&
                        activityList.length > 0 &&
                        activityList.map((activity, index) => (
                          <li key={index.toString()}>
                            <div className="db-approval-body d-flex">
                              <div className="avatar-img">
                                {activity.photoURL ? (
                                  <div className="img-box">
                                    <img
                                      src={activity.photoURL}
                                      alt={`${activity.firstName}${activity.lastName}`}
                                    />
                                  </div>
                                ) : (
                                  getFirstLetterOfName(activity)
                                )}
                              </div>
                              <div className="db-approval-details ms-auto">
                                <h4 className="mb-1 text-sm font-semibold text-grey-600">{activity.subject}</h4>
                                <div className="approval-time mb-2">
                                  <span>
                                    {activity.creationDate &&
                                      formatDateWithTime(activity.creationDate)}
                                  </span>{" "}
                                  |{" "}
                                  <span>
                                    {activity.creationDate &&
                                      formatDateWithShortMonth(
                                        activity.creationDate
                                      )}
                                  </span>
                                </div>

                                <ul className="mb-0 list-unstyled d-flex flex-column justify-content-start row-gap-2">
                                {activity.chatList &&
                                  activity.chatList.length > 0 &&
                                  activity.chatList.map((chat, index) => (
                                    <li
                                      className="db-approval-content p-3 rounded-3 border border-primary-200 bg-primary-50"
                                      key={index.toString()}
                                    >
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: chat.chatDetails,
                                        }}
                                      />
                                      <ul className="react-list">
                                        <li>
                                          <button
                                            type="button"
                                            className="thumb-btn thumb-like"
                                          >
                                            <img
                                              src="/assets/images/icons/thumb-icon.svg"
                                              alt=""
                                            />{" "}
                                            {chat.likesno}
                                          </button>
                                          <button
                                            type="button"
                                            className="thumb-btn thumb-dislike"
                                          >
                                            <img
                                              src="/assets/images/icons/thumb-icon.svg"
                                              alt=""
                                            />{" "}
                                            {chat.dislikesno}
                                          </button>
                                        </li>
                                      </ul>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </div>
                          </li>
                        ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>

            <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 if-taskbox">
              <Todos />
            </div>
          </div>
        </div>

        {/* Chat Bot */}
        <div className="chat-box">
          <div className="chatbox-header">
            <button className="close-btn">
              <i className="bx bxs-x-circle"></i>
            </button>
            <i className="bx bxs-message-detail"></i>
            <h6 className="use-title">Hi Adam 👋</h6>
            <span className="welcome-note">
              Welcome to <strong>PLUTO EDU</strong> Chat support.
            </span>
          </div>
          <div className="chatbox-body">
            <ul>
              {messageList &&
                messageList.length > 0 &&
                messageList.map((msg) => {
                  return msg.recipient_id === user.data ? (
                    <li className="client_message">
                      <div className="messageboard_box">
                        <div className="avatar-image">
                          <img
                            src="../assets/images/icons/pluto-bot_icon.svg"
                            alt=""
                          />
                        </div>
                        <div className="message_text">
                          {renderBotMessage(msg)}
                        </div>
                      </div>
                    </li>
                  ) : (
                    <li className="my_message">
                      <div className="messageboard_box">
                        <div className="avatar-image">
                          <img src="../assets/images/avatars/10.jpg" alt="" />
                        </div>
                        <div className="message_text">
                          <p>{msg.text}</p>
                        </div>
                      </div>
                    </li>
                  );
                })}

              {/* <li className="client_message">
                        <div className="messageboard_box">
                           <div className="avatar-image">
                              <img
                                 src="../assets/images/icons/pluto-bot_icon.svg"
                                 alt=""
                              />
                           </div>
                           <div className="message_text">
                              <p>Here is your approval list</p>

                              <div className="approval-list">
                                 <Slider {...settings}>
                                    <div className="approval-box">
                                       <div className="approval-details">
                                          <div className="date-box">16-09-22</div>
                                          <ul>
                                             <li>
                                                <small>#JU12565829</small>
                                             </li>
                                             <li>
                                                <h6 className="user-name">Nu'ma Hashim</h6>
                                             </li>
                                             <li>
                                                Degree: <strong>Applied Physics</strong>
                                             </li>
                                             <li>
                                                GPA: <strong>3.00</strong>
                                             </li>
                                             <li>
                                                Citizenship: <strong>Turkmenistan</strong>
                                             </li>
                                             <li>
                                                Avg Rating: <i className="bx bxs-star"></i>
                                                <strong>4.3</strong>
                                             </li>
                                             <li>
                                                <a href="#">
                                                   Open full profile{" "}
                                                   <i className="bx bx-link-external"></i>
                                                </a>
                                             </li>
                                          </ul>
                                       </div>
                                       <div className="d-flex gap-1 mt-3">
                                          <button
                                             className="btn btn-mini btn-block btn-success"
                                             type="button"
                                          >
                                             Approve
                                          </button>
                                          <button
                                             className="btn btn-mini btn-block btn-danger"
                                             type="button"
                                          >
                                             Deny
                                          </button>
                                       </div>
                                    </div>
                                    <div className="approval-box">
                                       <div className="approval-details">
                                          <div className="date-box">16-09-22</div>
                                          <ul>
                                             <li>
                                                <small>#JU12565829</small>
                                             </li>
                                             <li>
                                                <h6 className="user-name">Nu'ma Hashim</h6>
                                             </li>
                                             <li>
                                                Degree: <strong>Applied Physics</strong>
                                             </li>
                                             <li>
                                                GPA: <strong>3.00</strong>
                                             </li>
                                             <li>
                                                Citizenship: <strong>Turkmenistan</strong>
                                             </li>
                                             <li>
                                                Avg Rating: <i className="bx bxs-star"></i>
                                                <strong>4.3</strong>
                                             </li>
                                             <li>
                                                <a href="#">
                                                   Open full profile{" "}
                                                   <i className="bx bx-link-external"></i>
                                                </a>
                                             </li>
                                          </ul>
                                       </div>
                                       <div className="d-flex gap-1 mt-3">
                                          <button
                                             className="btn btn-mini btn-block btn-success"
                                             type="button"
                                          >
                                             Approve
                                          </button>
                                          <button
                                             className="btn btn-mini btn-block btn-danger"
                                             type="button"
                                          >
                                             Deny
                                          </button>
                                       </div>
                                    </div>
                                    <div className="approval-box">
                                       <div className="approval-details">
                                          <div className="date-box">16-09-22</div>
                                          <ul>
                                             <li>
                                                <small>#JU12565829</small>
                                             </li>
                                             <li>
                                                <h6 className="user-name">Nu'ma Hashim</h6>
                                             </li>
                                             <li>
                                                Degree: <strong>Applied Physics</strong>
                                             </li>
                                             <li>
                                                GPA: <strong>3.00</strong>
                                             </li>
                                             <li>
                                                Citizenship: <strong>Turkmenistan</strong>
                                             </li>
                                             <li>
                                                Avg Rating: <i className="bx bxs-star"></i>
                                                <strong>4.3</strong>
                                             </li>
                                             <li>
                                                <a href="#">
                                                   Open full profile{" "}
                                                   <i className="bx bx-link-external"></i>
                                                </a>
                                             </li>
                                          </ul>
                                       </div>
                                       <div className="d-flex gap-1 mt-3">
                                          <button
                                             className="btn btn-mini btn-block btn-success"
                                             type="button"
                                          >
                                             Approve
                                          </button>
                                          <button
                                             className="btn btn-mini btn-block btn-danger"
                                             type="button"
                                          >
                                             Deny
                                          </button>
                                       </div>
                                    </div>
                                 </Slider>
                              </div>
                           </div>
                        </div>
                     </li> */}
              {/* <li className="my_message">
                        <div className="messageboard_box">
                           <div className="avatar-image">
                              <img src="../assets/images/avatars/10.jpg" alt="" />
                           </div>
                           <div className="message_text">
                              <p>Gender graph of Applied Physics filed</p>
                           </div>
                        </div>
                     </li>
                     <li className="client_message">
                        <div className="messageboard_box">
                           <div className="avatar-image">
                              <img
                                 src="../assets/images/icons/pluto-bot_icon.svg"
                                 alt=""
                              />
                           </div>
                           <div className="message_text">
                              <p>Gender Ratio Graph for Applied Physics</p>

                              <div className="ratio-graph-box">
                                 <div className="ratio-graph-header">Gender Ratio</div>
                                 <div className="ratio-graph-body">
                                    <div className="graph-img text-center">
                                       <img src="../assets/images/graph2.png" alt="" />
                                    </div>
                                    <div className="ratio-graph-info">
                                       <ul>
                                          <li>
                                             <div className="gender-applicant male-ratio">
                                                <i className="bx bxs-circle"></i> Male Applicant
                                             </div>
                                             <div className="gender-ratio">
                                                500 <span>(75%)</span>
                                             </div>
                                          </li>
                                          <li>
                                             <div className="gender-applicant female-ratio">
                                                <i className="bx bxs-circle"></i> Female
                                                Applicant
                                             </div>
                                             <div className="gender-ratio">
                                                125 <span>(25%)</span>
                                             </div>
                                          </li>
                                       </ul>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </li>
                     <li className="my_message">
                        <div className="messageboard_box">
                           <div className="avatar-image">
                              <img src="../assets/images/avatars/10.jpg" alt="" />
                           </div>
                           <div className="message_text">
                              <p>Application No #JU12565829</p>
                           </div>
                        </div>
                     </li>
                     <li className="client_message">
                        <div className="messageboard_box">
                           <div className="avatar-image">
                              <img
                                 src="../assets/images/icons/pluto-bot_icon.svg"
                                 alt=""
                              />
                           </div>
                           <div className="message_text">
                              <p>Details of Application No #JU12565829</p>

                              <div className="approval-list">
                                 <div className="approval-box">
                                    <div className="approval-details">
                                       <ul>
                                          <li>
                                             <small>#JU12565829</small>
                                          </li>
                                          <li>
                                             <h6 className="user-name">Nu'ma Hashim</h6>
                                          </li>
                                          <li>
                                             Degree: <strong>Applied Physics</strong>
                                          </li>
                                          <li>
                                             GPA: <strong>3.00</strong>
                                          </li>
                                          <li>
                                             Citizenship: <strong>Turkmenistan</strong>
                                          </li>
                                          <li>
                                             Avg Rating: <i className="bx bxs-star"></i>
                                             <strong>4.3</strong>
                                          </li>
                                          <li>
                                             <a href="#">
                                                Edit profile <i className="bx bxs-pencil"></i>
                                             </a>
                                          </li>
                                       </ul>
                                    </div>
                                    <div className="d-flex gap-1 mt-3">
                                       <button
                                          className="btn btn-mini btn-block btn-success"
                                          type="button"
                                       >
                                          Approve
                                       </button>
                                       <button
                                          className="btn btn-mini btn-block btn-danger"
                                          type="button"
                                       >
                                          Deny
                                       </button>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </li>
                     <li className="my_message">
                        <div className="messageboard_box">
                           <div className="avatar-image">
                              <img src="../assets/images/avatars/10.jpg" alt="" />
                           </div>
                           <div className="message_text">
                              <p>Application No #JU12565829</p>
                              <p>Details of Application No #JU12565829</p>
                           </div>
                        </div>
                     </li> */}
            </ul>
          </div>
          <div className="chatbox-footer">
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder="Type a message here"
                value={message}
                onChange={handleChange}
              />
              <button type="button" className="input-group-text">
                <i className="bx bx-plus"></i>
              </button>
              <button
                type="button"
                className="input-group-text"
                onClick={onSendMessage}
              >
                <i className="bx bxs-send"></i>
              </button>
            </div>
          </div>
        </div>
        {/* <button type="button" className="chat-btn">
          <i className="bx bx-message-square-dots"></i>
        </button> */}
      </main>

      {filtersModal && (
        <Filters
          show={filtersModal}
          // filterList={filterList}
          // duplicateFilterList={duplicateFilterList}
          // setFilterList={setFilterList}
          toggle={toggleFiltersModal}
          onApplyFilter={onApplyFilter}
          onResetFilter={onResetFilter}
          // handleFilterSelectChange={handleFilterSelectChange}
          // handleFilterSliderChange={handleFilterSliderChange}
          // handleFilterDateChange={handleFilterDateChange}
          // handleFilterAssigneeChange={handleFilterAssigneeChange}
          // handleFilterCheckboxChange={handleFilterCheckboxChange}
          // handleSearchFilter={handleSearchFilter}
        />
      )}
    </>
  );
};

export default Dashboard;
